import * as React from 'react';
import {Platform, View} from 'react-native';
import {useNavigation} from '@react-navigation/native';

import {Button} from '../../../shared/components/button';
import {LoadableContent} from '../../../shared/components/loadableContent';
import {useStyles} from '../../../shared/hooks/styles';
import {DeviceSize, useDeviceSize} from '../../../shared/theme/helpers';
import {Screens} from '../../../shared/routing';
import {ProductResponsePayload} from '../../../shared/models/api/productResponsePayload';
import {ProductCard} from '../ProductCard/ProductCard';

const itemBaseWidth = 315;
const _itemHorizontalSpacing = 20;

const calcItemFlexBasis = (containerWidth: number): string => {
  const itemPerRow = Math.floor(containerWidth / itemBaseWidth);
  return `${100 / itemPerRow}%`;
};

interface Props {
  productsList: ProductResponsePayload[] | null;
  onShowMore: () => void;
  canShowMore: boolean;
}

export default ({productsList, onShowMore, canShowMore}: Props) => {
  const nav = useNavigation();
  const deviceSize = useDeviceSize();
  const [_itemFlexBasis, setItemFlexBasis] = React.useState<string>(deviceSize === DeviceSize.desktop ? '75%' : '100%');

  const styles = useStyles(({mediaOnly}) => {
    return {
      container: {
        flexDirection: Platform.OS === 'web' ? 'row' : 'column',
        flexWrap: Platform.OS === 'web' ? 'wrap' : 'nowrap',
        ...mediaOnly(
          DeviceSize.desktop,
          {justifyContent: 'flex-start', minHeight: 200, maxWidth: 945, alignItems: 'stretch'},
          {justifyContent: 'center', alignSelf: 'center'},
        ),
        gap: 10,
      },
      item: {
        marginVertical: 10,
      },
      itemCard: {},
      buttonContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        ...mediaOnly(
          DeviceSize.mobile,
          {paddingTop: 14, paddingBottom: 60},
          {paddingTop: 20, paddingBottom: 80, paddingHorizontal: 10},
        ),
      },
      showMoreButton: {
        marginLeft: 0,
        marginRight: 0,
        ...mediaOnly(DeviceSize.mobile, {width: '100%', maxWidth: 328}, {width: 200}),
      },
    };
  });

  const handleCardPress = React.useCallback((product: ProductResponsePayload) => {
    nav.navigate(Screens.ProductItem, {
      id: product.id,
    });
  }, []);

  return (
    <LoadableContent loading={!productsList}>
      <View
        testID='acceptor-list-id-666'
        style={styles.container}
        onLayout={(event) => {
          if (deviceSize !== DeviceSize.mobile) {
            setItemFlexBasis(calcItemFlexBasis(event.nativeEvent.layout.width));
          }
        }}>
        {productsList?.map((product) => (
          <View style={styles.item} key={product.id}>
            <ProductCard
              onPress={() => handleCardPress(product)}
              style={styles.itemCard}
              product={product}
              nameRows={2}
              shortDescriptionRows={2}
              flexHeight={false}
            />
          </View>
        ))}
      </View>
      <View style={styles.buttonContainer}>
        {canShowMore && (
          <Button
            id='acceptor-list-more'
            onPress={onShowMore}
            style={styles.showMoreButton}
            type='secondary'
            text='Показать еще'
          />
        )}
      </View>
    </LoadableContent>
  );
};
